module.exports = __webpack_public_path__ + "static/media/qrcode.0dfcd8da.jpg";